import { tagClass } from "@/lib/tags";

export const formatDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
};

// Format body — preserves line breaks, highlights standalone integers in gold
export const renderBody = (text) =>
  text.split("\n").map((line, i) => (
    <p key={`line-${i}-${line.slice(0, 20)}`} className="leading-relaxed" style={{ minHeight: "1.5em" }}>
      {line.split(/(\b\d+\b)/g).map((part, j) =>
        /^\d+$/.test(part) ? (
          <span key={`num-${i}-${j}-${part}`} className="gold font-semibold">
            {part}
          </span>
        ) : (
          <span key={`txt-${i}-${j}-${part.slice(0, 10)}`}>{part}</span>
        )
      )}
    </p>
  ));

export { tagClass };
